
import WikiImg from '~/components/common/wikiImg/index.vue'

export default {
  components: { WikiImg },
  inject: ['detail'],
  props: {
    softval: {
      type: Number,
      default: 1
    },
    ctraderSoftwareList: {
      type: Array,
      default: () => []
    },
    selfSoftwareList: {
      type: Array,
      default: () => []
    },
    companyCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headData: this.detail.main,
      show: false,
      imgArr: [],
      bigimgShow: false,
      iosArr: [],
      winArr: [],
      isDragging: false,
      startX: 0,
      scrollLeft: 0
    }
  },
  watch: {
    show(v) {
      if (v) {
        document.body.style.setProperty('overflow', 'hidden', 'important')
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  mounted() {
    if (document && document.documentElement && document.documentElement.clientWidth <= 999) {
      this.listCount = 4
    } else {
      this.listCount = 5
    }
    window.addEventListener('resize', () => {
      if (document && document.documentElement && document.documentElement.clientWidth <= 999) {
        this.listCount = 4
      } else {
        this.listCount = 5
      }
    })
    const that = this
    document.addEventListener('keydown', function (e) {
      if (e.keyCode == 27) {
        that.bigimgShow = false
      }
    })
    // console.log(this.wapShow, 'wapShow1111');
    console.log(this.softval, 'softval222')
  },
  methods: {
    close() {
      // 关闭弹框
      document.body.style.overflow = 'auto'
      this.show = false
    },
    open() {
      this.show = true
    },
    detailsClick(item) {
      const codeParams = item.marketId + '-' + item.appBundleId + '-' + this.companyCode + '-' + item.showPlatform
      window.open(`/${this.$store.state.LanguageCode}/softwareDetails/${codeParams}.html`)
    },
    // 鼠标事件处理
    startDrag(e, index, val) {
      this.isDragging = true
      this.startX = e.pageX - this.$refs.scrollContainer[index].offsetLeft
      this.scrollLeft = this.$refs.scrollContainer[index].scrollLeft
      this.$refs.scrollContainer[0].style.cursor = 'grabbing'
      e.stopPropagation()
      // 防止选中文本
      e.preventDefault()
    },
    stopDrag(e, index, val) {
      // 拖动结束逻辑
      setTimeout(() => {
        this.isDragging = false
      }, 50)
      this.$refs.scrollContainer[index].style.cursor = 'grab'
    },
    onDrag(e, index, val) {
      if (!this.isDragging) return
      const x = e.pageX - this.$refs.scrollContainer[index].offsetLeft
      const walk = (x - this.startX) * 2 // 滚动速度系数
      this.$refs.scrollContainer[index].scrollLeft = this.scrollLeft - walk
      // 拖拽时阻止事件冒泡
      e.stopPropagation()
      e.preventDefault()
    },
    handleContainerClick(event) {
      event.stopPropagation() // 阻止冒泡到外层
    }
  }
}
